import { decorateWindowForExperiments } from './experiments';

export function decorateWindow(): void {
	decorateWindowForExperiments();
}
